<div class="business-settings-page">
  <section class="overview-hero">
    <div class="hero-copy">
      <span class="hero-kicker">Business Settings</span>

      <h1>Account & <span>Store Settings</span></h1>

      <p>
        Manage your business profile, store details, permissions, billing,
        integrations, security, and notification preferences from one settings
        workspace.
      </p>
    </div>
  </section>

  <section class="kpi-grid">
    <article class="kpi-card kpi-card--primary">
      <div>
        <span>Settings Centre</span>
        <strong>{{ tabs.length }}</strong>
        <p>Business configuration areas available.</p>
      </div>

      <!-- <img [src]="assetUrl + 'icons/settings.svg'" alt="" /> -->
    </article>

    <article class="kpi-card">
      <div>
        <span>Store Profile</span>
        <strong>Ready</strong>
        <p>Manage public profile, logo, photos, and branding.</p>
      </div>

      <!-- <img [src]="assetUrl + 'icons/doc-border.svg'" alt="" /> -->
    </article>

    <article class="kpi-card">
      <div>
        <span>Integrations</span>
        <strong>Connected</strong>
        <p>Connect Square and other business platforms to gloget.</p>
      </div>

      <!-- <img [src]="assetUrl + 'icons/integration-border.svg'" alt="" /> -->
    </article>

    <article class="kpi-card">
      <div>
        <span>Billing</span>
        <strong>Secure</strong>
        <p>Payment details are handled securely through Square.</p>
      </div>

      <!-- <img [src]="assetUrl + 'icons/dollar-border.svg'" alt="" /> -->
    </article>
  </section>

  <section class="panel">
    <header class="panel-head">
      <div>
        <span class="panel-kicker">Configuration</span>
        <h2>Settings Centre</h2>
        <p>Keep your account, store, and operating preferences up to date.</p>
      </div>
    </header>

    <div class="settings-tabs-shell">
      <glo-tabs [tabs]="tabs">
        <ng-template gloTabContent="details">
          <business-account-details></business-account-details>
        </ng-template>

        <ng-template gloTabContent="store">
          <business-account-store></business-account-store>
        </ng-template>

        <ng-template gloTabContent="permissions">
          <business-account-permissions></business-account-permissions>
        </ng-template>

        <ng-template gloTabContent="password">
          <business-account-password></business-account-password>
        </ng-template>

        <ng-template gloTabContent="billing">
          <business-account-billing></business-account-billing>
        </ng-template>

        <ng-template gloTabContent="integrations">
          <business-account-integrations></business-account-integrations>
        </ng-template>

        <ng-template gloTabContent="notification">
          <business-account-notification></business-account-notification>
        </ng-template>
      </glo-tabs>
    </div>
  </section>
</div>
